import DTI from "dom-to-image";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";

export default class ScreenShot {
  dom;
  eId;
  canvas;
  canvasCtx;

  constructor(eId) {
    this.eId = eId;
  }

  shot() {
    const el = document.getElementById(this.eId);

    const iframe = document.getElementById("iframe").contentWindow;
    // const playWind =

    console.log(" iframe:", iframe);

    if (!el) return false;
    // DTI.toBlob(el).then(blob => {
    //   window.saveAs(blob, "shot.png");
    // });

    html2canvas(el).then(_canvas => {
      console.log("_canvas:", _canvas);
      try {
        const link = document.createElement("img");
        //将图片转换为base64
        link.src = _canvas.toDataURL();

        console.log(" link.src:", link.src);

        link.style.width = "100%";
        link.style.height = "100%";
        link.style.position = "absolute";
        link.style.top = "0";
        link.style.left = "0";
        el.appendChild(link);
      } catch (e) {
        console.error(e);
      }
    });
  }
}
